<template>
  <section class="view-endorsement-quote">
    <div class="abs-top-right">
      <v-button @click="handlerBack">Back</v-button>
    </div>

    <h2>View Paid Endorsement Quote</h2>

    <endorsement-info
      :isCancel="isCancel"
      :premiumData="premiumData"
      :info="true"
      :form="form"
      :orderId="orderId"
      :oldForm="oldForm" />
  </section>
</template>
<script>
import EndorsementInfo from './endorsement-info'
import {getCancelQuoteResult} from '@/api/endorsement'
export default {
  name: 'ViewEndorsementQuote',
  components: {
    EndorsementInfo
  },
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    oldForm: {
      type: Object,
      default: () => ({})
    },
    action: {
      type: [String, Number],
      default: 1 // 1 - endorse, 2 - cancel
    },
    ticketId: {
      type: [String, Number],
      default: ''
    },
    orderId: {
      type: [String, Number],
      default: ''
    },
  },
  data() {
    return {
      premiumData: {
        diff_payable: {},
        new_premium: {},
        old_premium: {},
        extra_benefits_premium: {},
        type: 1,
        is_manual_quote: 0
      },
    }
  },
  computed:{
    isCancel() {
      return this.action != 1
    },
  },
  mounted(){
    if(this.isCancel){
      this.network().getCancelQuoteResult({
        order_id: this.orderId,
        ticket_id: this.ticketId,
        pcy_cmnt_dt: this.form.pcy_cmnt_dt,
        pcy_expry_dt: this.form.pcy_expry_dt,
      })
    }
  },
  methods: {
    handlerBack() {
      this.$emit('back')
    },

    network(){
      return {
        getCancelQuoteResult: async params => {
          const { data } = await getCancelQuoteResult(params)
          const { old_premium, diff_payable, remain_premium, extra_benefits_premium } = data
          this.premiumData = {
            old_premium,
            diff_payable,
            remain_premium,
            extra_benefits_premium
          }
        },
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.view-endorsement-quote {
    position: relative;
    padding: 15px;
    .abs-top-right {
        top: 15px;
        right: 15px;
    }
}
</style>